var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showNotice)?_c('div',{class:`alert alert-${_vm.type} d-block opacity-1 my-4`},[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_c('br'),_vm._v("\n    "+_vm._s(_vm.promoPeriodHint)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }